export default __webpack_public_path__ + "fonts/71e33d2040989313baf03c782f9901ab.svg";